// extracted by mini-css-extract-plugin
module.exports = {"tabs":"_2wlbuSIggD1FgOp1zBqsK4","swimlane":"_38LGhpERW4LQ0GAW3vcJOH"};